import React, { useEffect } from "react";
import { useFormik } from "formik";
import { Grid } from "@mui/material";
import "./style.scss";
import { applicantCountConstant } from "../../../config/constant";
import editIcon from "../../../assets/icons/ic-solar_pen-bold.svg";
import TextFieldInput from "../../../components/TextFieldInput";
import { useDispatch, useSelector } from "react-redux";
import CommonButtonVoucherForm from "../../../shared-components/common-button/CommonButtonVoucherForm";
import { enableEditForm, setActiveStep } from "../voucher-form.slice";
import { route } from "../../../services/apiRoutes";
import { useParams } from "react-router-dom";

const ApplicantReviewCard = () => {
  const { voucherId } = useParams();
  const applicantReviewFormik = useFormik({
    initialValues: {
      applicantDataList: [],
    },
  });

  const dispatch = useDispatch();
  const { applicantData, activeStep } = useSelector(
    (state) => state?.voucherForm
  );

  useEffect(() => {
    let applicatList = [];
    if (applicantData?.noOfApplicants) {
      for (let i = 1; i <= applicantData?.noOfApplicants; i++) {
        if (applicantData[`applicant${i}`] !== null) {
          applicatList.push({
            name: `${
              applicantData[`applicant${i}`]?.personalDetails?.firstName || ""
            } ${
              applicantData[`applicant${i}`]?.personalDetails?.lastName || ""
            }`,
            email:
              applicantData[`applicant${i}`]?.personalDetails?.emailAddress ||
              applicantData[`applicant${i}`]?.contactDetails?.emailAddress ||
              "",
            mobile:
              applicantData[`applicant${i}`]?.personalDetails?.contactNumber ||
              applicantData[`applicant${i}`]?.contactDetails?.contactNumber ||
              "",
            aadhaarNumber:
              applicantData[`applicant${i}`]?.contactDetails?.aadhaarNumber ||
              "",
            panNumber:
              applicantData[`applicant${i}`]?.contactDetails?.panNumber || "",
            passportNumber:
              applicantData[`applicant${i}`]?.contactDetails?.passportNumber ||
              "",
            ociNumber:
              applicantData[`applicant${i}`]?.contactDetails?.ociNumber || "",
            OCIAlternateDocType:
              applicantData[`applicant${i}`]?.contactDetails
                ?.OCIAlternateDocType || "",
            countryCode:
              applicantData[`applicant${i}`]?.contactDetails?.countryCode || "",
          });
        }
      }
    }
    applicantReviewFormik.setFieldValue("applicantDataList", applicatList);
  }, [applicantData]);

  const handleSaveForm =async (type) => {
      const payload = {
        lastStep: applicantData?.noOfApplicants + 1,
      };
      const res = await dispatch(
        enableEditForm({
          path: `${route.ENABLE_EDIT}/${voucherId}`,
          payload,
          opportunityId: voucherId,
        })
      ).unwrap();
  
      // ✅ Navigate only on success response
      if (res?.status === 200 || res?.status === 201) {
          dispatch(setActiveStep(activeStep + 1));
      }
  };

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  return (
    <div className="applicantReviewCardContainer">
      <form onSubmit={applicantReviewFormik.handleSubmit}>
        <Grid container spacing={2}>
          {applicantReviewFormik?.values?.applicantDataList?.map(
              (data, index) => {
                return (
                  <Grid key={`${data?.firstName}-${data?.emailAddress || index}`} item xs={12} sm={12} md={6} lg={6}>
                    <div className="box">
                      <div>
                        <div className="actionTop">
                          <div className="applicantNumber">
                            <span>
                              {index + 1 === 1 ? (
                                applicantCountConstant.numberKeys[1]
                              ) : (
                                <>
                                  {index + 1}
                                  <span className="textTop">
                                    <sup>
                                      {
                                        applicantCountConstant.numberKeys[
                                          index + 1
                                        ]
                                      }
                                    </sup>
                                  </span>
                                </>
                              )}{" "}
                              Applicant
                            </span>
                          </div>
                          <button
                            onClick={() => {
                              dispatch(setActiveStep(index));
                            }}
                            className="editIcon resetButton"
                          >
                            <img alt="" src={editIcon}></img>
                          </button>
                        </div>

                        <div className="marginBottom24">
                          <TextFieldInput
                            sx={{ mb: 3 }}
                            field={{
                              name: "name",
                              label: "Name",
                              required: false,
                              readonly: true,
                              value: data?.name || "",
                            }}
                            formik={applicantReviewFormik}
                          />
                        </div>
                        <div className="marginBottom24">
                          <TextFieldInput
                            field={{
                              name: "email",
                              label: "Email",
                              required: false,
                              readonly: true,
                              value: data?.email || "",
                            }}
                            formik={applicantReviewFormik}
                          />
                        </div>

                        <div className="marginBottom24">
                          <TextFieldInput
                            field={{
                              name: "mobile",
                              label: "Mobile",
                              required: false,
                              readonly: true,
                              value: `${
                                data?.countryCode + data?.mobile || ""
                              }`,
                            }}
                            formik={applicantReviewFormik}
                          />
                        </div>
                        {data?.aadhaarNumber &&
                        data?.aadhaarNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "aadhaarNumber",
                                label: "Aadhaar Number",
                                required: false,
                                readonly: true,
                                value: data?.aadhaarNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.panNumber && data?.panNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "panNumber",
                                label: "PAN Number",
                                required: false,
                                readonly: true,
                                value: data?.panNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.passportNumber &&
                        data?.passportNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "passportNumbe",
                                label: "Passport Number",
                                required: false,
                                readonly: true,
                                value: data?.passportNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.ociNumber && data?.ociNumber?.length > 0 ? (
                          <div className="marginBottom24">
                            <TextFieldInput
                              field={{
                                name: "ociNumber",
                                label: "OCI Number",
                                required: false,
                                readonly: true,
                                value: data?.ociNumber || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                        {data?.OCIAlternateDocType &&
                        data?.OCIAlternateDocType?.length > 0 ? (
                          <div>
                            <TextFieldInput
                              field={{
                                name: "OCIAlternateDocType",
                                label: "Other Document",
                                required: false,
                                readonly: true,
                                value: data?.OCIAlternateDocType || "",
                              }}
                              formik={applicantReviewFormik}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Grid>
                );
              }
            )}
        </Grid>

        <CommonButtonVoucherForm
          handleNext={handleSaveForm}
          handlePrevious={handlePrevious}
          saveDraftData={{}}
          saveForLater={false}
        />
      </form>
    </div>
  );
};

export default ApplicantReviewCard;
